// extracted by mini-css-extract-plugin
var _1 = "Items-moduleitems__W2cDe MultiValuedListItems-moduleMultiValuedListItems__sFyGz";
export { _1 as "items" }
